var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill-inherit",
    viewBox: "0 0 817 1155",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "vecteezy_padlock-icon-lock-and-unlock-icon-vector-design_",
    transform: "translate(-660.000000, -488.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105.19,1248.53 L1105.19,1388.13 C1105.19,1401.93 1094.08,1413.03 1080.28,1413.03 L1057.39,1413.03 C1043.68,1413.03 1032.59,1401.93 1032.59,1388.13 L1032.59,1248.53 C1011.08,1234.33 998.384,1207.83 1004.58,1179.03 C1009.89,1154.33 1029.89,1134.43 1054.58,1129.23 C1097.18,1120.33 1134.78,1152.53 1134.78,1193.63 C1134.78,1216.53 1122.98,1236.73 1105.19,1248.53 Z M1068.88,586.476 C1171.68,586.476 1255.32,670.115 1255.32,772.917 L1255.32,898.129 L882.436,898.129 L882.436,772.917 C882.436,670.115 966.074,586.476 1068.88,586.476 Z M1348.78,898.17 L1353.63,898.17 L1353.63,772.917 C1353.63,615.904 1225.89,488.17 1068.88,488.17 C911.865,488.17 784.126,615.904 784.126,772.917 L784.126,898.17 L788.886,898.17 C718.159,898.604 660.984,956.099 660.984,1026.93 L660.984,1513.83 C660.984,1584.93 718.584,1642.53 789.685,1642.53 L1347.98,1642.53 C1419.18,1642.53 1476.78,1584.93 1476.78,1513.83 L1476.78,1026.93 C1476.78,956.099 1419.61,898.604 1348.78,898.17 L1348.78,898.17 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.951bd3d23c35baa724fb54f11f67d77d.svg";
export { ForwardRef as ReactComponent };